import { render, staticRenderFns } from "./Skus2Sale.vue?vue&type=template&id=0fee5bed&scoped=true&"
import script from "./Skus2Sale.vue?vue&type=script&lang=js&"
export * from "./Skus2Sale.vue?vue&type=script&lang=js&"
import style0 from "./Skus2Sale.vue?vue&type=style&index=0&id=0fee5bed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee5bed",
  null
  
)

export default component.exports